import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { IDIChannelFilter } from '../../lib/asyncMessageHelper';

// Get default contact options from IDI response for IDI enabled markets
const getDefaultOptions = () => {
  const IDIContactChannels = Page.getIDIContactOptions();

  if (Array.isArray(IDIContactChannels) && IDIContactChannels.length > 0) {
    return IDIChannelFilter(IDIContactChannels);
  }

  return [{ type: 'community', priority: '1' }, { type: 'seller', priority: '2' }, { type: 'email', priority: '3' }, { type: 'callus', priority: '4' }];
};

const initialState = {
  isLoading: false,
  channels: getDefaultOptions(),
  error: false,
  display: Page.isValidToDisplayContactOptions(),
  reachToResult: false,
  emailSelected: false,
  IDIEnable: false,
  IDIIsLoaded: false,
  IDIChannels: [],
  IDIAvailability: [],
  IDIError: false,
  isSACLoaded: false,
  hasFinalContactOptions: false,
  finalContactOptions: [],
  OriginalRiskResponse: [],
  isIdiServiceLoaded: false,
  isIdiLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_TOPIC_DATA:
      return { ...state, isLoading: true, isSACLoaded: false };
    case types.RECEIVE_TOPIC_DATA_ERROR:
      return {
        ...state, isLoading: false, error: true, display: true, isSACLoaded: true, channels: initialState.channels.filter((channel) => channel.type !== 'email'),
      };
    case types.RECEIVE_TOPIC_DATA_RESPONSE:
      return {
        ...state, isLoading: false, error: false, display: true, channels: [...action.payload], isSACLoaded: true,
      };
    case types.REQUEST_IDI_CONTACT_OPTIONS:
      return {
        ...state, IDIEnable: true, IDIChannels: [], IDIAvailability: [], IDIIsLoaded: false, IDIError: false,
      };
    case types.RECEIVE_IDI_CONTACT_OPTIONS_RESPONSE:
      return {
        ...state, IDIChannels: [...action.payload.channels], IDIIsLoaded: true, IDIError: false, IDIAvailability: [...action.payload.availability],
      };
    case types.REQUEST_RESPONSE_FROM_RISK:
      return { ...state, isIdiServiceLoaded: false, isIdiLoading: true };
    case types.RECEIVED_RESPONSE_FROM_RISK:
      return {
        ...state, OriginalRiskResponse: action.payload, IDIError: false, isIdiServiceLoaded: true, isIdiLoading: false,
      };
    case types.RECEIVE_IDI_CONTACT_OPTIONS_ERROR:
      return {
        ...state, IDIEnable: false, IDIIsLoaded: true, IDIError: true, isIdiServiceLoaded: true, isIdiLoading: false,
      };
    case types.RECEIVE_CONTACT_CHANNELS_NO_DATA:
      return { ...state, channels: [...action.payload] };
    case types.SELECT_TOPIC_L1:
    case types.SELECT_TOPIC_L2:
    case types.SELECT_TOPIC_L3:
    case types.SELECT_TOPIC_RESET:
      return {
        ...state,
        channels: initialState.channels,
        display: initialState.display,
        reachToResult: false,
        IDIIsLoaded: false,
        IDIEnable: false,
        IDIError: false,
        IDIChannels: [],
        IDIAvailability: [],
        hasFinalContactOptions: false,
        OriginalRiskResponse: [],
      };
    case types.SELECT_RESULT:
      return { ...state, reachToResult: true };
    case types.REQUEST_BY_EMAIL:
    case types.RECEIVE_EMPTY_FIELDS:
      return {
        ...state, display: false, reachToResult: false, emailSelected: true,
      };
    case types.LOGOUT:
      return { ...state, display: Page.isValidToDisplayContactOptions() };
    case types.LOGIN: {
      return { ...state, display: Page.isValidToDisplayContactOptions() };
    }
    case types.CHANGE_TOPIC:
      return { ...state, display: initialState.display };
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
      // Reset contact options for cancel the email selection in the bypass email page
      // reassign reachToResult for ByPass topic tree reach to end, to avoid using IDI contact options
      return initialState;
    case types.CANCEL_EMAIL_FORM:
      return {
        ...state, display: true, emailSelected: false, reachToResult: true,
      };
    case types.RECEIVE_TOPIC_TREE_ERROR: // Showing Contact Option for topic tree Fallback
      return { ...state, display: true };
    case types.UPDATE_FINAL_CONTACT_OPTIONS: {
      return { ...state, hasFinalContactOptions: true, finalContactOptions: action.payload };
    }
    default:
      return state;
  }
}
